import type { AnalyticsActionOrigin, AnalyticsState } from '../types';

export interface Props {
  actionOrigin?: AnalyticsActionOrigin;
}
export const actionOriginReducer = (
  state: AnalyticsState,
  props: Props,
): AnalyticsState => {
  const { actionOrigin, ...restState } = state;

  return {
    ...restState,
    ...(props.actionOrigin ? { actionOrigin: props.actionOrigin } : {}),
  };
};
